import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';

import { IDwLoadMaskCfg } from '../interface/loading.interface';

/**
 * HTTP加載遮罩
 */
@Component({
  selector: 'dw-loading-http',
  templateUrl: './loading-http.component.html',
  encapsulation: ViewEncapsulation.None
  // changeDetection: ChangeDetectionStrategy.OnPush // 避免ExpressionChangedAfterItHasBeenCheckedError
})
export class DwLoadingHttpComponent implements OnInit, OnDestroy {
  public loadingMask: IDwLoadMaskCfg;

  constructor() {
  }
  ngOnInit(): void {
  }

  public ngOnDestroy(): void {
  }
}
